import AED from "../assets/images/flags/1f1e6-1f1ea.png"
import AUD from "../assets/images/flags/1f1e6-1f1fa.png"
import BGN from "../assets/images/flags/1f1e7-1f1ec.png"
import BRL from "../assets/images/flags/1f1e7-1f1f7.png"
import CAD from "../assets/images/flags/1f1e8-1f1e6.png"
import CHF from "../assets/images/flags/1f1e8-1f1ed.png"
import CZK from "../assets/images/flags/1f1e8-1f1ff.png"
import DKK from "../assets/images/flags/1f1e9-1f1f0.png"
import EUR from "../assets/images/flags/1f1ea-1f1fa.png"
import GBP from "../assets/images/flags/1f1ec-1f1e7.png"
import HKK from "../assets/images/flags/1f1ed-1f1f0.png"
import HRK from "../assets/images/flags/1f1ed-1f1f7.png"
import HUF from "../assets/images/flags/1f1ed-1f1fa.png"
import IDR from "../assets/images/flags/1f1ee-1f1e9.png"
import INR from "../assets/images/flags/1f1ee-1f1f3.png"
import JPY from "../assets/images/flags/1f1ef-1f1f5.png"
import MYR from "../assets/images/flags/1f1f2-1f1fe.png"
import NOK from "../assets/images/flags/1f1f3-1f1f4.png"
import NZD from "../assets/images/flags/1f1f3-1f1ff.png"
import PLN from "../assets/images/flags/1f1f5-1f1f1.png"
import RON from "../assets/images/flags/1f1f7-1f1f4.png"
import SEK from "../assets/images/flags/1f1f8-1f1ea.png"
import SGD from "../assets/images/flags/1f1f8-1f1ec.png"
import TRY from "../assets/images/flags/1f1f9-1f1f7.png"
import UAH from "../assets/images/flags/1f1fa-1f1e6.png"
import USD from "../assets/images/flags/1f1fa-1f1f8.png"


import EN from "../assets/images/flags/1f1ec-1f1e7.png"
import FR from "../assets/images/flags/1f1eb-1f1f7.png"
import DE from "../assets/images/flags/1f1e9-1f1ea.png"
import EL from "../assets/images/flags/1f1ec-1f1f7.png"
import HU from "../assets/images/flags/1f1ed-1f1fa.png"
import IT from "../assets/images/flags/1f1ee-1f1f9.png"
import LT from "../assets/images/flags/1f1f1-1f1f9.png"
import PL from "../assets/images/flags/1f1f5-1f1f1.png"
import PT from "../assets/images/flags/1f1f5-1f1f9.png"
import UK from "../assets/images/flags/1f1fa-1f1e6.png"
import HI from "../assets/images/flags/1f1ee-1f1f3.png"

import AE from "../assets/images/flags/AE.png"
import CN from "../assets/images/flags/CN.png"
import ES from "../assets/images/flags/ES.png"
import NL from "../assets/images/flags/NL.png"
import CZ from "../assets/images/flags/CZ.png"




// Above image was download from https://www.jsdelivr.com/package/npm/emoji-datasource cdn link
// https://projects.iamcal.com/emoji-data/table.htm
const FlagImages = {
  AED,
  AUD,
  BGN,
  BRL,
  CAD,
  CHF,
  CZK,
  DKK,
  EUR,
  GBP,
  HKK,
  HRK,
  HUF,
  IDR,
  INR,
  JPY,
  MYR,
  NOK,
  NZD,
  PLN,
  RON,
  SEK,
  SGD,
  TRY,
  UAH,
  USD,

  EN,
  FR,
  DE,
  EL,
  HU,
  IT,
  LT,
  PL,
  PT,
  UK,
  HI,
  AE,
  CN,
  ES,
  NL,
  ZH: CN,
  AR: AE,
  CZ,
  GB: EN
} as const

export default FlagImages
